import type { Components } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const MuiIconButton: Components<Omit<Theme, 'components'>>['MuiIconButton'] = {
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        backgroundColor: '#fff',
      },
    },
  },
};
